import { render, staticRenderFns } from "./TkDeclarativeTabs.vue?vue&type=template&id=4a9da697&"
import script from "./TkDeclarativeTabs.vue?vue&type=script&lang=js&"
export * from "./TkDeclarativeTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports